const initialState = [
  {
    xStreamURLData: [],
  },
];

const xStreamUrlVerifyReducer = (state = initialState, action) => {
  switch (action.type) {
    case "XSTREAM_URL_VERIFY":
      return {
        ...state,
        xStreamURLData: action.payload,
      };
    default:
      return state;
  }
};

export default xStreamUrlVerifyReducer;
